import React, { ReactChild } from 'react';
import { DetailsContainer } from './HBAccordion.styles';
import { useAccordionAnimation } from '../../hooks/useAccordionAnimation';

export interface HBAccordionDetailsProps {
    children: ReactChild | ReactChild[];
}

const HBAccordionDetails = ({ children }: HBAccordionDetailsProps) => {
    const animation = useAccordionAnimation();
    return <DetailsContainer {...animation}>{children}</DetailsContainer>;
};

export default HBAccordionDetails;
